module.exports = __webpack_public_path__ + "assets/img/best-in-test-logo.276a5c79.png";